import { computed, onMounted, ref } from "vue";
import { useMassSignatureStore } from "../stores/mass-signature.store";
import { useUserPreferencesStore } from "../stores/user-preferences.store";

export function useMassSign() {
  const massSignatureStore = useMassSignatureStore();
  const userPrefStore = useUserPreferencesStore();
  const isMassSignEnabled = computed(() => massSignatureStore.enabled);
  const isMassSignOpen = ref(false);
  onMounted(() => {
    if (massSignatureStore.currentMassSignature?.creationDate) {
      isMassSignOpen.value = true;
    }
  });

  function toggleMassSignSelect(id: number) {
    if (!verifyHasSignatureObject()) return;
    massSignatureStore.toggleSelection(id);
  }

  function verifyHasSignatureObject() {
    const hasSignatureObject = userPrefStore.signatureObjects.length > 0;
    if (!hasSignatureObject) {
      alert("Vous devez d'abord ajouter une griffe pour pouvoir signer");
    }
    return hasSignatureObject;
  }

  return {
    isMassSignOpen,
    isMassSignEnabled,
    massSignatureStore,
    verifyHasSignatureObject,
    toggleMassSignSelect,
  };
}
